import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type WorkspacePermissionsFragment = { action: Types.WorkspaceActions, subject: Types.WorkspaceSubjects };


export type WorkspacePermissionsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const WorkspacePermissionsFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkspacePermissions on UserWorkspacePermissionType {
  action
  subject
}
    `;